import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanLoad, Router, Route } from '@angular/router';
import { AuthService } from '../auth.service';
@Injectable()
export class WelcomeGuard implements CanActivate {

    constructor(private authService: AuthService,
                private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.checkLoggedIn(state.url);
    }
    
    checkLoggedIn(url: string): boolean {
        
        if (this.authService.isLoggedIn()) {            
            this.router.navigate(['/home']);
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/welcome/welcome-guard.service.ts